/* After a new entry, send the visitor to the Stack page. Falls back to the "check your email" panel if that page is not published. */
(function () {
  var panel = document.querySelector('[data-gw-state="thanks"]');
  if (!panel || new URLSearchParams(location.search).get('gw_preview')) return;
  var done = false;
  new MutationObserver(function () {
    if (panel.hidden || done) return;
    done = true;
    fetch('/pages/365-stack', { method: 'HEAD' }).then(function (r) {
      if (r.ok) setTimeout(function () { location.href = '/pages/365-stack?e=1'; }, 700);
    }).catch(function () {});
  }).observe(panel, { attributes: true, attributeFilter: ['hidden'] });
})();